const BASE36 = "0123456789abcdefghijklmnopqrstuvwxyz";
const CAPITAL_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const BASE = 36;
const FIXED_LENGTH = 15;

// Converts a positive long integer to a Base36 encoded string
export function encode(value: number) {
  if (value <= 0) {
    return "0";
  }

  let encoded = "";
  while (value > 0) {
    const remainder = value % BASE;
    encoded += BASE36[remainder];
    value = Math.floor(value / BASE);
  }

  return padWithRandomCaps(encoded.split("").reverse().join(""));
}

// Pads the encoded string to a fixed length with random capital letters
function padWithRandomCaps(str: string) {
  let padded = str;
  while (padded.length < FIXED_LENGTH) {
    const index = Math.floor(Math.random() * CAPITAL_LETTERS.length);
    padded += CAPITAL_LETTERS[index];
  }
  return padded.substring(0, FIXED_LENGTH);
}

// Decodes a padded Base36 string back to a positive long integer
export function decode(paddedEncoded: string) {
  const base36String = paddedEncoded.replace(/[A-Z]/g, ""); // Remove capital letters
  return fromBase36(base36String);
}

// Converts a Base36 string back to a positive long integer
function fromBase36(str: string) {
  let value = 0;
  for (let char of str) {
    value = value * BASE + BASE36.indexOf(char);
  }
  return value;
}

// Example usage
const original = 987654321234567890; // Example positive number
const paddedEncoded = encode(original);
const decoded = decode(paddedEncoded);
